<div class="nav">
  <ng-container *ngIf="isAuth">
    <ng-container *ngIf="app === 'wm-tech'">
      <a mat-button href="{{ env.techMmsDomain }}">{{ 'WM_TECH.HEADER.MMS' | translate }}</a>
      <div class="menu-line"></div>
      <a mat-button href="{{ env.techPoolDomain }}">{{ 'WM_TECH.HEADER.POOL' | translate }}</a>
    </ng-container>

    <ng-container *ngIf="app === 'wm-tech-mms'">
      <a mat-button routerLink="/" routerLinkActive="/" class="bold">{{ 'WM_TECH.HEADER.MMS' | translate }}</a>
      <div class="menu-line"></div>
      <a mat-button href="{{ env.techPoolDomain }}">{{ 'WM_TECH.HEADER.POOL' | translate }}</a>
    </ng-container>

    <ng-container *ngIf="app === 'wm-tech-pool'">
      <a mat-button href="{{ env.techMmsDomain }}">{{ 'WM_TECH.HEADER.MMS' | translate }}</a>
      <div class="menu-line"></div>
      <a mat-button routerLink="/statistics" routerLinkActive="/statistics" class="bold">{{ 'WM_TECH.HEADER.POOL' | translate }}</a>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!isAuth">
    <ng-container *ngIf="app === 'wm-tech'">
      <a mat-button routerLink="/auth/sign-in" routerLinkActive="/" [queryParams]="{ redirectToMms: true }">{{ 'WM_TECH.HEADER.MMS' | translate }}</a>

      <div class="menu-line"></div>

      <a mat-button routerLink="/auth/sign-in" routerLinkActive="/" [queryParams]="{ redirectToPool: true }">{{ 'WM_TECH.HEADER.POOL' | translate }}</a>
    </ng-container>
  </ng-container>
</div>
